import { useState, useEffect, useRef } from "react";
import moment from "moment";

import { useParams } from "react-router-dom";
import { menu } from "../js/menu";
import { disconnect, userData } from "../js/utils";
import { post } from "../js/post";

import PatientSearch from "./PatientSearch";
import Panel from "./Panel";
import Patient from "./Patient";
import Empty from "./Empty";
import Settings from "../support/screens/Settings";
import Textfields from "./debug/TextFields";
import Exports from "./debug/Exports";
import Skeleton from "./debug/Skeleton";
import OptionMenu from "../components/OptionMenu";
import TopBar from "../components/TopBar";
import PopupMessage from "../components/PopupMessage";
import MenuOption from "../components/MenuOption";
import OptometryScreen from "../components/OptometryScreen";
import Audiometry from "../components/Audiometry";
import ObservationsPanel from "../components/ObservationsPanel";
import Store from "./Store";
import ProductPanel from "../components/ProductPanel";
import DeliveryNote from "./DeliveryNote";
import DeliveryNotePanel from "../components/DeliveryNotePanel";
import BulkEdit from "../components/BulkEdit";
import Glasses from "../components/Glasses";
import ActionPopup from "../components/ActionPopup";
import HearingAids from "../components/HearingAids";
import ContactLenses from "../components/ContactLenses";
import ShoppingCart from "../components/ShoppingCart";
import Calendar from "../support-extra/screens/Calendar";
import Sales from "../support-extra/screens/Sales";
import Sale from "../support-extra/screens/Sale";
import Order from "../support-extra/screens/Order";
import Quote from "../support-extra/screens/Quote";
import Proforma from "../support-extra/screens/Proforma";
import CRM from "./CRM";
import Dashboard from "./Dashboard";
import DashboardSales from "../support-extra/screens/DashboardSales";
import DashboardStore from "../support-extra/screens/DashboardStore";
import DashboardPatients from "../support-extra/screens/DashboardPatients";
import CashPopupDebug from "./debug/CashPopup";
import CashPopup from "../support-extra/components/CashPopup";
import DashboardSeeMorePopup from "../components/DashboardSeeMorePopup";
import DashboardStoreSeeMorePopup from "../components/DashboardStoreSeeMorePopup";
import Reports from "./debug/Reports";
import OnlineOrders from "./debug/OnlineOrders";
import WacomSignature from "./debug/WacomSignature";
import GodexPrinting from "./debug/GodexPrinting";
import { InvoicePanel } from "./InvoicePanel";
import DocumentManagement from "./DocumentManagement";
import { Orders } from "./Orders";
import Suppliers from "./Suppliers";
import LaborControl from "../support-extra/screens/LaborControl";
import PopupPin from "../support-extra/components/PopupPin";

export default function Main() {
  let { screenId, params } = useParams();

  let [screens, setScreens] = useState([]);
  const [currentScreen, setCurrentScreen] = useState(
    screenId ? screenId : "panel",
  );
  const [currentShownScreen, setCurrentShownScreen] = useState(
    screenId ? screenId : "panel",
  );
  const componentVars = useRef();
  const screenPatientRef = useRef();
  const screenSaleRef = useRef();
  const screenOrderRef = useRef();
  const screenQuoteRef = useRef();
  const screenProformaRef = useRef();

  const [paramsPatient, setParamsPatient] = useState(
    screenId === "patient-datos" ? { patientId: params } : null,
  );
  const [paramsSales, setParamsSales] = useState(
    screenId === "ventas" ? { debtor: params } : null,
  );
  const [paramsSale, setParamsSale] = useState(
    screenId === "venta" ? { saleId: params } : null,
  );
  const [paramsOrder, setParamsOrder] = useState(
    screenId === "encargo" ? { saleId: params } : null,
  );
  const [paramsQuote, setParamsQuote] = useState(
    screenId === "presupuesto" ? { saleId: params } : null,
  );
  const [paramsProforma, setParamsProforma] = useState(
    screenId === "proforma" ? { saleId: params } : null,
  );
  const [paramsAlbaran, setParamsAlbaran] = useState(
    screenId === "almacen-albaran" ? { albaranId: params } : null,
  );
  const [paramsPatientSearch, setParamsPatientSearch] = useState({ reload: 0 });
  const [popupQuestion, setPopupQuestion] = useState(null);
  const [showPinPopup, setShowPinPopup] = useState(false);
  const [laborControlAgent, setLaborControlAgent] = useState(null);

  const [showOptoPanel, setShowOptoPanel] = useState(false);
  const [optoPatient, setOptoPatient] = useState(null);
  const [obsObjectId, setObsObjectId] = useState(null);
  const [optoTabIndex, setOptoTabIndex] = useState(-1);
  const [lastOptoIds, setLastOptoIds] = useState(null);
  const [lastAudiometryId, setLastAudiometryId] = useState(-1);
  const [lastGlassesId, setLastGlassesId] = useState(-1);
  const [lastHearingAidsId, setLastHearingAidsId] = useState(-1);
  const [lastContactLensesId, setLastContactLensesId] = useState(-1);
  const [optoOnCloseAction, setOptoOnCloseAction] = useState(null);
  const [audiometryOnCloseAction, setAudiometryOnCloseAction] = useState(null);
  const [glassesOnCloseAction, setGlassesOnCloseAction] = useState(null);
  const [optoNewOptometry, setOptoNewOptometry] = useState(false);
  const [audioNewAudiometria, setAudioNewAudiometria] = useState(false);
  const [newGlasses, setNewGlasses] = useState(false);
  const [newLenses, setNewLenses] = useState(false);
  const [newHearingAid, setNewHearingAid] = useState(false);
  const [showAudiometryPanel, setShowAudiometryPanel] = useState(false);
  const [showGlassesPanel, setShowGlassesPanel] = useState(false);
  const [showHearingAidsPanel, setShowHearingAidsPanel] = useState(false);
  const [showContactLensesPanel, setShowContactLensesPanel] = useState(false);
  const [showObservationsPanel, setShowObservationsPanel] = useState(false);
  const [showShoppingCart, setShowShoppingCart] = useState(false);
  const [showProductPanel, setShowProductPanel] = useState(false);
  const [showDeliveryNotePanel, setShowDeliveryNotePanel] = useState(false);
  const [showBulkEditPanel, setShowBulkEditPanel] = useState(false);
  const [observationsOnCloseAction, setObservationsOnCloseAction] =
    useState(null);
  const [bulkEditOnCloseAction, setBulkEditOnCloseAction] = useState(null);
  const [productOnCloseAction, setProductOnCloseAction] = useState(null);
  const [deliveryNoteOnCloseAction, setDeliveryNoteOnCloseAction] =
    useState(null);
  const [obsCategory, setObsCategory] = useState("");
  const [productCode, setProductCode] = useState(null);
  const [supplierCode, setSupplierCode] = useState(-1);
  const [deliveryNoteCode, setDeliveryNoteCode] = useState(null);
  const [selectedProductFamily, setSelectedProductFamily] = useState(-1);
  const [productList, setProductList] = useState([]);
  const [updatedBEProductList, setUpdatedBEProductList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [actionPopup, setActionPopup] = useState(null);
  const [actionComponent, setActionComponent] = useState(null);
  const [deliveryNoteProducts, setDeliveryNoteProducts] = useState([]);
  const [cashPopupData, setCashPopupData] = useState({
    selectedOpticId: "",
    type: "",
    show: false,
    startDate: "",
    endDate: "",
  });
  const [dashboardSalesSeeMore, setDashboardSalesSeeMore] = useState({
    selectedOpticId: "",
    opticName: "",
    startDate: "",
    endDate: "",
    show: false,
    agentId: "",
  });
  const [dashboardStoreSeeMore, setDashboardStoreSeeMore] = useState({
    supplierId: "",
    supplierName: "",
    startDate: "",
    endDate: "",
    show: false,
    brand: "",
  });

  let prevW = -1;
  let menuHTML = null;
  let contentHTML = null;

  const MAX_W = 1080;

  // console.log("PRODUCTLIST MAIN: ", productList);
  // console.log("UPDATED BE PRODUCT LIST: ", updatedBEProductList);

  let openOptoPanel = (patientInfo, tabId, ids, onCloseAction) => {
    setOptoPatient(patientInfo);
    setOptoTabIndex(tabId);
    setLastOptoIds(ids);
    setOptoOnCloseAction(() => onCloseAction);
    setShowOptoPanel(true);
  };

  let closeOptoPanel = () => {
    setOptoPatient(null);
    setOptoTabIndex(-1);
    setLastOptoIds(null);
    setOptoOnCloseAction(null);
    setShowOptoPanel(false);
    setOptoNewOptometry(false);
  };

  let openAudiometryPanel = (patientInfo, id, onCloseAction) => {
    setOptoPatient(patientInfo);
    setLastAudiometryId(id);
    setAudiometryOnCloseAction(() => onCloseAction);
    setShowAudiometryPanel(true);
  };

  let closeAudiometryPanel = () => {
    setOptoPatient(null);
    setLastAudiometryId(-1);
    setAudiometryOnCloseAction(null);
    setShowAudiometryPanel(false);
    setAudioNewAudiometria(false);
  };

  let openGlassesPanel = (patientInfo, id, onCloseAction) => {
    setOptoPatient(patientInfo);
    setLastGlassesId(id);
    setGlassesOnCloseAction(() => onCloseAction);
    setShowGlassesPanel(true);
  };

  let closeGlassesPanel = () => {
    setOptoPatient(null);
    setLastGlassesId(-1);
    setGlassesOnCloseAction(null);
    setShowGlassesPanel(false);
    setNewGlasses(false);
  };

  let openHearingAidsPanel = (patientInfo, id, onCloseAction) => {
    setOptoPatient(patientInfo);
    setLastHearingAidsId(id);
    setGlassesOnCloseAction(() => onCloseAction);
    setShowHearingAidsPanel(true);
  };

  let closeHearingAidsPanel = () => {
    setOptoPatient(null);
    setLastHearingAidsId(-1);
    setGlassesOnCloseAction(null);
    setShowHearingAidsPanel(false);
    setNewHearingAid(false);
  };

  let openContactLensesPanel = (patientInfo, id, onCloseAction) => {
    setOptoPatient(patientInfo);
    setLastContactLensesId(id);
    setGlassesOnCloseAction(() => onCloseAction);
    setShowContactLensesPanel(true);
  };

  let closeContactLensesPanel = () => {
    setOptoPatient(null);
    setLastContactLensesId(-1);
    setGlassesOnCloseAction(null);
    setShowContactLensesPanel(false);
    setNewLenses(false);
  };

  let openObservationsPanel = (
    patientInfo,
    objectId,
    onCloseAction,
    category,
  ) => {
    setOptoPatient(patientInfo);
    setObsObjectId(objectId);
    setObsCategory(category);
    setShowObservationsPanel(true);
    setObservationsOnCloseAction(() => onCloseAction);
  };

  let closeObservationsPanel = () => {
    setOptoPatient(null);
    setObsObjectId(null);
    setShowObservationsPanel(false);
    setObservationsOnCloseAction(null);
  };

  let closeSuppliersPanel = () => {
    setObsObjectId(null);
  };

  let openProductPanel = (family, code, onCloseAction) => {
    setProductCode(code);
    setSelectedProductFamily(family);
    setShowProductPanel(true);
    setProductOnCloseAction(() => onCloseAction);
  };

  let closeProductPanel = () => {
    setObsObjectId(null);
    setShowProductPanel(false);
    setProductOnCloseAction(null);
  };

  let openBulkEditPanel = (family, products, onCloseAction) => {
    if (products.length > 0) {
      setShowBulkEditPanel(true);
      setSelectedProductFamily(family);
      setProductList(products);
      setBulkEditOnCloseAction(() => onCloseAction);
    } else {
      createPopupQuestion(
        `Seleccione productos para edición masiva.`,
        removePopupQuestion,
        null,
        "Entendido",
      );
    }
  };

  let openDeliveryNotePanel = (code, onCloseAction) => {
    setDeliveryNoteCode(code);
    setShowDeliveryNotePanel(true);
    setDeliveryNoteOnCloseAction(() => onCloseAction);
  };

  let closeDeliveryNotePanel = () => {
    setObsObjectId(null);
    setShowDeliveryNotePanel(false);
    setDeliveryNoteOnCloseAction(null);
  };

  useEffect(() => {
    if (paramsAlbaran && paramsAlbaran.albaranId) {
      openDeliveryNotePanel(paramsAlbaran.albaranId, true);
    }
  }, [paramsAlbaran]);

  const openCashPopup = (
    selectedOpticId,
    type,
    show,
    startDate,
    endDate,
    seeMore,
    opticName,
    agentId,
  ) => {
    const commonData = {
      selectedOpticId,
      opticName,
      show,
      startDate,
      endDate,
      agentId,
    };

    switch (seeMore) {
      case 0:
        setDashboardSalesSeeMore((prev) => ({ ...prev, ...commonData }));
        break;
      case 1:
        setDashboardStoreSeeMore((prev) => ({
          ...prev,
          supplierId: selectedOpticId,
          supplierName: opticName,
          brand: agentId,
          ano: moment(startDate).year(),
          show,
        }));
        break;
      case -1:
        setCashPopupData((prev) => ({ ...prev, ...commonData, type }));
        break;
      default:
    }
  };

  let menuOver = () => {
    menuHTML.classList.remove("sidebar-app-hidden");
  };

  let menuOut = () => {
    menuHTML.classList.add("sidebar-app-hidden");
  };

  let goBack = async () => {
    componentVars.prevScreens.pop();
    componentVars.prevScreensParams.pop();
    if (componentVars.prevScreens.length === 0) {
      clickMenuOption("panel");
    } else {
      clickMenuOption(
        componentVars.prevScreens[componentVars.prevScreens.length - 1],
        componentVars.prevScreensParams[
          componentVars.prevScreensParams.length - 1
        ],
      );
    }
  };

  let createMenu = () => {
    menu.forEach((m) => {
      m.submenuOpen = false;
      m.subsections.forEach((s) => {
        s.submenuOpen = false;
      });
    });
    setScreens(menu);
    screens = menu;
  };

  useEffect(() => {
    if (actionComponent !== null) {
      setActionPopup(true);
    }
  }, [actionComponent]);

  useEffect(() => {
    createMenu();

    menuHTML = document.querySelector("div.sidebar-app");
    contentHTML = document.querySelector("div.dashboard-app");

    const w =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    if (w <= MAX_W) {
      menuHTML.classList.add("sidebar-app-hidden");
      menuHTML.classList.add("sidebar-app-hidden-abs");
      contentHTML.classList.add("dashboard-app-reduced");
      menuHTML.addEventListener("mouseover", menuOver);
      menuHTML.addEventListener("mouseout", menuOut);
    }
    if (w > MAX_W) {
      menuHTML.classList.remove("sidebar-app-hidden");
      menuHTML.classList.remove("sidebar-app-hidden-abs");
      contentHTML.classList.remove("dashboard-app-reduced");
      menuHTML.removeEventListener("mouseover", menuOver);
      menuHTML.removeEventListener("mouseout", menuOut);
    }

    prevW = w;

    window.addEventListener("resize", () => {
      const w =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      if (prevW > MAX_W && w <= MAX_W) {
        menuHTML.classList.add("sidebar-app-hidden");
        menuHTML.classList.add("sidebar-app-hidden-abs");
        menuHTML.addEventListener("mouseover", menuOver);
        menuHTML.addEventListener("mouseout", menuOut);
      }
      if (prevW <= MAX_W && w > MAX_W) {
        menuHTML.classList.remove("sidebar-app-hidden");
        menuHTML.classList.remove("sidebar-app-hidden-abs");
        menuHTML.removeEventListener("mouseover", menuOver);
        menuHTML.removeEventListener("mouseout", menuOut);
      }

      prevW = w;
    });

    componentVars.prevScreens = [];
    componentVars.prevScreensParams = [];

    window.history.pushState(null, null, document.URL);
    window.addEventListener("popstate", function () {
      window.history.pushState(null, null, document.URL);
      createMenu();
      goBack();
    });
  }, []);

  let scrollTo = (id) => {
    const element = document.querySelectorAll("div.dashboard-options")[0];
    if (element) {
      const el = document.querySelector(id);
      if (el) {
        let scrollDiv = el.offsetTop;
        element.scrollTo({
          top: scrollDiv,
          behavior: "smooth",
        });
      }
    }
  };

  const createPopupQuestion = (
    text,
    onClickAccept,
    onClickCancel,
    textAccept,
    textCancel,
    onClickExtra1,
    textExtra1,
    onClickExtra2,
    textExtra2,
  ) => {
    setPopupQuestion({
      text,
      onClickCancel,
      onClickAccept,
      textAccept,
      textCancel,
      onClickExtra1,
      textExtra1,
      onClickExtra2,
      textExtra2,
    });
  };

  let removePopupQuestion = () => {
    setPopupQuestion(null);
  };

  let changeOptics = () => {
    window.location = "/main";
  };

  let clickMenuOption = async (screenId, params = null) => {
    // Ventanas especiales

    if (
      currentScreen.startsWith("patient-") &&
      currentScreen !== "patient-search" &&
      (!screenId.startsWith("patient-") || screenId === "patient-search") &&
      params == null
    ) {
      // Se dirige de una pantalla de paciente (que podría estar modificada) a otra que no es de paciente
      screenPatientRef.current.onChangeScreen(() =>
        clickMenuOption(screenId, true),
      );
      return;
    }

    if (currentScreen === "venta" && params == null) {
      const change = screenSaleRef.current.canChangeScreen(screenId, params);
      if (change) {
        setCurrentScreen("");
        clickMenuOption(screenId, true);
      }
      return;
    }

    if (currentScreen === "encargo" && params == null) {
      const change = screenOrderRef.current.canChangeScreen(screenId, params);
      if (change) {
        setCurrentScreen("");
        clickMenuOption(screenId, true);
      }
      return;
    }

    if (currentScreen === "presupuesto" && params == null) {
      const change = screenQuoteRef.current.canChangeScreen(screenId, params);
      if (change) {
        setCurrentScreen("");
        clickMenuOption(screenId, true);
      }
      return;
    }

    if (currentScreen === "proforma" && params == null) {
      const change = screenProformaRef.current.canChangeScreen(
        screenId,
        params,
      );
      if (change) {
        setCurrentScreen("");
        clickMenuOption(screenId, true);
      }
      return;
    }

    if (screenId === "control-laboral" && params !== "pin-verified") {
      setShowPinPopup(true);
      return;
    }

    if (screenId === "patient-datos-nuevo") {
      // Creación de nuevo paciente
      clickMenuOption("patient-datos", { patientId: -1 });
      return;
    }
    if (screenId === "patient-datos") {
      if (currentShownScreen === "patient-datos") {
        if (!params) {
          // Scroll
          setTimeout(() => scrollTo("[id='Datos']", 500));
          setCurrentScreen(screenId);
          return;
        }
      } else {
        let screen = screens.find((s) => {
          return s.id === "patient-search";
        });
        if (screen) {
          if (screen.submenuOpen) {
            // Vuelve a mostrar la ficha
            setCurrentScreen(screenId);
            setCurrentShownScreen("patient-datos");
            setTimeout(() => scrollTo("[id='Datos']", 500));
            return;
          }
        }
      }
    }
    if (screenId === "patient-compras") {
      if (currentShownScreen === "patient-datos") {
        // Scroll
        setTimeout(() => scrollTo("[id='Compras']", 500));
        setCurrentScreen(screenId);
      } else {
        // Vuelve a mostrar la ficha
        setCurrentScreen(screenId);
        setCurrentShownScreen("patient-datos");
        setTimeout(() => scrollTo("[id='Compras']", 500));
      }
      return;
    }
    if (screenId === "patient-optometria") {
      if (currentShownScreen === "patient-datos") {
        // Scroll
        setTimeout(() => scrollTo("[id='Optometría']", 500));
        setCurrentScreen(screenId);
      } else {
        // Vuelve a mostrar la ficha
        setCurrentScreen(screenId);
        setCurrentShownScreen("patient-datos");
        setTimeout(() => scrollTo("[id='Optometría']", 500));
      }
      return;
    }
    if (screenId === "patient-audiometria") {
      if (currentShownScreen === "patient-datos") {
        // Scroll
        setTimeout(() => scrollTo("[id='Audiometría']", 500));
        setCurrentScreen(screenId);
      } else {
        // Vuelve a mostrar la ficha
        setCurrentScreen(screenId);
        setCurrentShownScreen("patient-datos");
        setTimeout(() => scrollTo("[id='Audiometría']", 500));
      }
      return;
    }
    if (screenId === "patient-gafas") {
      if (currentShownScreen === "patient-datos") {
        // Scroll
        setTimeout(() => scrollTo("[id='Gafas']", 500));
        setCurrentScreen(screenId);
      } else {
        // Vuelve a mostrar la ficha
        setCurrentScreen(screenId);
        setCurrentShownScreen("patient-datos");
        setTimeout(() => scrollTo("[id='Gafas']", 500));
      }
      return;
    }
    if (screenId === "patient-lentes-contacto") {
      if (currentShownScreen === "patient-datos") {
        // Scroll
        setTimeout(() => scrollTo("[id='Lentes de contacto']", 500));
        setCurrentScreen(screenId);
      } else {
        // Vuelve a mostrar la ficha
        setCurrentScreen(screenId);
        setCurrentShownScreen("patient-datos");
        setTimeout(() => scrollTo("[id='Lentes de contacto']", 500));
      }
      return;
    }
    if (screenId === "patient-audifonos") {
      if (currentShownScreen === "patient-datos") {
        // Scroll
        setTimeout(() => scrollTo("[id='Audífonos']", 500));
        setCurrentScreen(screenId);
      } else {
        // Vuelve a mostrar la ficha
        setCurrentScreen(screenId);
        setCurrentShownScreen("patient-datos");
        setTimeout(() => scrollTo("[id='Audífonos']", 500));
      }
      return;
    }
    if (screenId === "patient-varios") {
      if (currentShownScreen === "patient-datos") {
        // Scroll
        setTimeout(() => scrollTo("[id='Varios']", 500));
        setCurrentScreen(screenId);
      } else {
        // Vuelve a mostrar la ficha
        setCurrentScreen(screenId);
        setCurrentShownScreen("patient-datos");
        setTimeout(() => scrollTo("[id='Varios']", 500));
      }
      return;
    }

    if (screenId === "patient-compras-nuevo") {
      // Creación de nueva venta

      let patientId = -1;
      const el = document.querySelector("#patient-id");
      if (el) {
        const pId = el.textContent;
        if (pId != -1) {
          patientId = pId;
        }
      }

      clickMenuOption("venta", { saleId: -1, orderPatientId: patientId });

      return;
    }

    if (screenId === "patient-optometria-nuevo") {
      // Creación de nueva optometría

      setOptoNewOptometry(true);

      return;
    }
    if (screenId === "patient-audiometria-nuevo") {
      // Creación de nueva audiometría

      setAudioNewAudiometria(true);

      return;
    }

    if (screenId === "patient-gafas-nuevo") {
      // Creación de nueva ficha de gafas

      setNewGlasses(true);

      return;
    }

    if (screenId === "patient-lentes-contacto-nuevo") {
      // Creación de nueva ficha de lentes de contacto

      setNewLenses(true);

      return;
    }

    if (screenId === "patient-audifonos-nuevo") {
      // Creación de nueva ficha de audífono

      setNewHearingAid(true);

      return;
    }

    // Gestión del go back
    if (
      componentVars.prevScreens.length === 0 ||
      (componentVars.prevScreens.length > 0 &&
        componentVars.prevScreens[componentVars.prevScreens.length - 1] !==
          screenId)
    ) {
      componentVars.prevScreens.push(screenId);
      componentVars.prevScreensParams.push(params);
    }

    let screen = null;
    screens.forEach((sc) => {
      sc.subsections.forEach((s_) => {
        if (s_.id === screenId) {
          screen = s_;
        }
      });
      if (sc.id === screenId) {
        screen = sc;
      }
    });

    if (screen) {
      setCurrentScreen(screenId);
      if (screenId !== "dashboard") {
        setCurrentShownScreen(screen.screenToShow);
      }
      screen.submenuOpen = false;

      let parentScreen = screens.find((sc) => {
        const p = sc.subsections.find((s) => {
          return s.id === screenId;
        });
        return p ? sc : null;
      });
      let parent = "";
      if (parentScreen && screen.showInMenu) {
        parentScreen.submenuOpen = screenId;
        parent = parentScreen.id;
      }

      switch (screen.screenToShow) {
        // Only pages with extra params
        case "patient-datos":
          setParamsPatient(params);
          break;
        case "ventas":
          setParamsSales(params);
          break;
        case "venta":
          setParamsSale(params);
          break;
        case "encargo":
          setParamsOrder(params);
          break;
        case "presupuesto":
          setParamsQuote(params);
          break;
        case "proforma":
          setParamsProforma(params);
          break;
        case "almacen-albaran":
          setParamsAlbaran(params);
          break;
      }

      // Especial navegación almacen
      if (screenId === "almacen") {
        screen.submenuOpen = true;
        setCurrentScreen(screenId);
        setCurrentShownScreen(screenId);
      } else {
        if (parent !== "almacen") {
          let s = screens.find((sc) => {
            return sc.id === "almacen";
          });
          s.submenuOpen = false;
        }
      }

      // Especial navegación debug
      if (screenId === "debug") {
        screen.submenuOpen = true;
      } else {
        if (parent !== "debug") {
          let s = screens.find((sc) => {
            return sc.id === "debug";
          });
          s.submenuOpen = false;
        }
      }

      // Especial navegación dashboard
      if (screenId === "dashboard") {
        screen.submenuOpen = true;
      } else {
        if (parent !== "dashboard") {
          let s = screens.find((sc) => {
            return sc.id === "dashboard";
          });
          s.submenuOpen = false;
        }
      }

      setScreens([...screens]);
    } else {
      setCurrentScreen("");
      setCurrentShownScreen("");
    }
  };

  return (
    <div className="welcome-screen">
      {popupQuestion && (
        <PopupMessage
          text={popupQuestion.text}
          onClickCancel={popupQuestion.onClickCancel}
          onClickAccept={popupQuestion.onClickAccept}
          textAccept={popupQuestion.textAccept}
          textCancel={popupQuestion.textCancel}
          onClickExtra1={popupQuestion.onClickExtra1}
          textExtra1={popupQuestion.textExtra1}
          onClickExtra2={popupQuestion.onClickExtra2}
          textExtra2={popupQuestion.textExtra2}
        ></PopupMessage>
      )}
      <PopupPin
        show={showPinPopup}
        onAccept={(agent) => {
          setShowPinPopup(false);
          setLaborControlAgent(agent);
          clickMenuOption("control-laboral", "pin-verified");
        }}
        onCancel={() => setShowPinPopup(false)}
      />
      {showOptoPanel && (
        <OptometryScreen
          onClose={() => {
            if (optoOnCloseAction) {
              optoOnCloseAction();
            }
          }}
          patientInfo={optoPatient}
          tabId={optoTabIndex}
          optIds={lastOptoIds}
          openObservationsPanel={(
            patientInfo,
            objectId,
            onCloseAction,
            category,
          ) => {
            openObservationsPanel(
              patientInfo,
              objectId,
              onCloseAction,
              category,
            );
          }}
          closeObservationsPanel={() => {
            closeObservationsPanel();
          }}
        />
      )}
      {showAudiometryPanel && (
        <Audiometry
          onClose={() => {
            if (audiometryOnCloseAction) {
              audiometryOnCloseAction();
            }
          }}
          patientInfo={optoPatient}
          audiometryId={lastAudiometryId}
        ></Audiometry>
      )}
      {showGlassesPanel && (
        <Glasses
          onClose={() => {
            if (glassesOnCloseAction) {
              glassesOnCloseAction();
            }
          }}
          patientInfo={optoPatient}
          id={lastGlassesId}
          createPopupQuestion={(
            text,
            onClickAccept,
            onClickCancel,
            textAccept,
            textCancel,
          ) =>
            createPopupQuestion(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            )
          }
          removePopupQuestion={removePopupQuestion}
          onClickMenuOption={(screenId, params) =>
            clickMenuOption(screenId, params)
          }
        ></Glasses>
      )}
      {showHearingAidsPanel && (
        <HearingAids
          onClose={() => {
            if (glassesOnCloseAction) {
              glassesOnCloseAction();
            }
          }}
          patientInfo={optoPatient}
          id={lastHearingAidsId}
          createPopupQuestion={(
            text,
            onClickAccept,
            onClickCancel,
            textAccept,
            textCancel,
          ) =>
            createPopupQuestion(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            )
          }
          removePopupQuestion={removePopupQuestion}
          onClickMenuOption={(screenId, params) =>
            clickMenuOption(screenId, params)
          }
        ></HearingAids>
      )}
      {showContactLensesPanel && (
        <ContactLenses
          onClose={() => {
            if (glassesOnCloseAction) {
              glassesOnCloseAction();
            }
          }}
          patientInfo={optoPatient}
          id={lastContactLensesId}
          createPopupQuestion={(
            text,
            onClickAccept,
            onClickCancel,
            textAccept,
            textCancel,
          ) =>
            createPopupQuestion(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            )
          }
          removePopupQuestion={removePopupQuestion}
          onClickMenuOption={(screenId, params) =>
            clickMenuOption(screenId, params)
          }
        ></ContactLenses>
      )}
      {showObservationsPanel && (
        <ObservationsPanel
          objectInfo={obsObjectId}
          category={obsCategory}
          onClose={() => {
            if (observationsOnCloseAction) {
              observationsOnCloseAction();
            }
            setShowObservationsPanel(false);
          }}
        ></ObservationsPanel>
      )}
      {actionPopup && (
        <ActionPopup
          name={actionComponent.name}
          children={actionComponent.component}
          onClose={() => {
            if (actionComponent.onRequestClose) {
              actionComponent.onRequestClose();
            } else {
              setActionPopup(false);
              setActionComponent(null);
            }
          }}
        ></ActionPopup>
      )}
      {showShoppingCart && (
        <ShoppingCart
          patientId={paramsPatient && paramsPatient.patientId}
          createPopupQuestion={(
            text,
            onClickAccept,
            onClickCancel,
            textAccept,
            textCancel,
          ) =>
            createPopupQuestion(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            )
          }
          removePopupQuestion={removePopupQuestion}
          onClose={() => {
            setShowShoppingCart(false);
          }}
          onClickMenuOption={(screenId, params) =>
            clickMenuOption(screenId, params)
          }
        ></ShoppingCart>
      )}
      {showBulkEditPanel && (
        <BulkEdit
          productFamily={selectedProductFamily}
          products={productList}
          onClose={(products) => {
            if (bulkEditOnCloseAction) {
              bulkEditOnCloseAction();
            }
            setShowBulkEditPanel(false);
            // console.log(">>> PRODUCTOS EDITADOS: ", products);
            setUpdatedBEProductList(products);
          }}
        ></BulkEdit>
      )}
      {showDeliveryNotePanel && (
        <DeliveryNotePanel
          id={deliveryNoteCode}
          createPopupQuestion={(
            text,
            onClickAccept,
            onClickCancel,
            textAccept,
            textCancel,
            onClickExtra1,
            textExtra1,
            onClickExtra2,
            textExtra2,
          ) =>
            createPopupQuestion(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
              onClickExtra1,
              textExtra1,
              onClickExtra2,
              textExtra2,
            )
          }
          removePopupQuestion={removePopupQuestion}
          openProductPanel={(
            family,
            code,
            onCloseAction,
            supplierCode,
            brandList,
          ) => {
            openProductPanel(family, code, onCloseAction);
            if (supplierCode) {
              setSupplierCode(supplierCode);
            }
            setBrandList(brandList);
          }}
          closeProductPanel={() => {
            closeProductPanel();
          }}
          onClose={() => {
            if (productOnCloseAction) {
              productOnCloseAction();
            }
            setDeliveryNoteProducts([]);
            setShowDeliveryNotePanel(false);
          }}
          createdProducts={deliveryNoteProducts}
        ></DeliveryNotePanel>
      )}
      {showProductPanel && (
        <ProductPanel
          productFamily={selectedProductFamily}
          productCode={productCode}
          supplierCode={supplierCode}
          brandList={brandList}
          registerFromDeliveryNote={selectedProductFamily === -1}
          createPopupQuestion={(
            text,
            onClickAccept,
            onClickCancel,
            textAccept,
            textCancel,
          ) =>
            createPopupQuestion(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            )
          }
          removePopupQuestion={removePopupQuestion}
          onClose={() => {
            if (productOnCloseAction) {
              productOnCloseAction();
            }
            setShowProductPanel(false);
          }}
          onDBProducts={async (e, f) => {
            const response = await post(
              "support-extra/albaran/AnadirNuevoProductoAlbaran.php",
              {
                token: userData.token,
                idAlbaran: deliveryNoteCode,
                familia: f,
                producto: e,
              },
            );

            if (response.error !== "") {
              createPopupQuestion(
                response.error,
                removePopupQuestion,
                null,
                "Entendido",
              );
            }

            if (response.error === "" && response.idProductoAlbaran) {
              setDeliveryNoteProducts((prev) => [...prev, e]);
            }
            return response;
          }}
        ></ProductPanel>
      )}
      <CashPopup
        opticaId={cashPopupData.selectedOpticId}
        fechaInicio={cashPopupData.startDate}
        fechaFin={cashPopupData.endDate}
        tipo={cashPopupData.type}
        show={cashPopupData.show}
        onClose={() =>
          setCashPopupData((prev) => {
            return {
              ...prev,
              selectedOpticId: "",
              type: "",
              show: false,
              startDate: "",
              endDate: "",
            };
          })
        }
        createPopupQuestion={cashPopupData.createPopupQuestion}
        removePopupQuestion={cashPopupData.removePopupQuestion}
      />
      <DashboardSeeMorePopup
        opticId={dashboardSalesSeeMore.selectedOpticId}
        opticName={dashboardSalesSeeMore.opticName}
        ano={moment(dashboardSalesSeeMore.startDate).year()}
        agentId={dashboardSalesSeeMore.agentId}
        show={dashboardSalesSeeMore.show}
        onClose={() =>
          setDashboardSalesSeeMore((prev) => {
            return {
              ...prev,
              selectedOpticId: "",
              opticName: "",
              startDate: "",
              endDate: "",
              show: false,
              agentId: "",
            };
          })
        }
      />
      <DashboardStoreSeeMorePopup
        supplierId={dashboardStoreSeeMore.supplierId}
        supplierName={dashboardStoreSeeMore.supplierName}
        ano={dashboardStoreSeeMore.ano}
        brand={dashboardStoreSeeMore.brand}
        show={dashboardStoreSeeMore.show}
        onClose={() =>
          setDashboardStoreSeeMore((prev) => {
            return {
              ...prev,
              supplierId: "",
              supplierName: "",
              startDate: "",
              endDate: "",
              show: false,
              brand: "",
            };
          })
        }
      />
      <div className="sidebar-app">
        <div className="sidebar-top">
          <img
            loading="lazy"
            sizes="7vw"
            src="/images/logo-h.png"
            alt="Logo"
            className="optiwin-logo"
          />
          <img
            loading="lazy"
            sizes="7vw"
            src="/images/optiwin-white.png"
            alt="Logo"
            className="optiwin-logo-small"
          />

          {/** MENU */}
          <div className="menu">
            {screens.map((e, i) => {
              return (
                <MenuOption
                  key={i}
                  item={e}
                  currentScreen={currentScreen}
                  clickMenuOption={clickMenuOption}
                />
              );
            })}
          </div>
          {/** */}
        </div>
        <div className="sidebar-down">
          <OptionMenu
            icon="/images/logout-icon.svg"
            text="Salir"
            onClick={() =>
              createPopupQuestion(
                "¿Desea cerrar sesión y salir de OPTIWIN?",
                () => disconnect(),
                () => removePopupQuestion(),
              )
            }
          />
        </div>
      </div>
      <div className="dashboard-app">
        <TopBar onChangeOptics={() => changeOptics()} />
        <div className="dashboard-options">
          <Panel
            show={currentShownScreen === "panel"}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            onGoBack={() => goBack()}
          />
          <PatientSearch
            show={currentShownScreen === "patient-search"}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            onGoBack={() => goBack()}
            reload={paramsPatientSearch.reload}
          />
          <Patient
            ref={screenPatientRef}
            show={currentShownScreen === "patient-datos"}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            patientId={paramsPatient && paramsPatient.patientId}
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
              onClickExtra1,
              textExtra1,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
                onClickExtra1,
                textExtra1,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            openOptoPanel={(patientInfo, tabId, optIds, onCloseAction) =>
              openOptoPanel(patientInfo, tabId, optIds, onCloseAction)
            }
            closeOptoPanel={() => closeOptoPanel()}
            onGoBack={() => goBack()}
            newOptometry={optoNewOptometry}
            newAudiometry={audioNewAudiometria}
            newGlasses={newGlasses}
            newLenses={newLenses}
            newHearingAid={newHearingAid}
            openAudiometryPanel={(patientInfo, id, onCloseAction) => {
              openAudiometryPanel(patientInfo, id, onCloseAction);
            }}
            closeAudiometryPanel={() => {
              closeAudiometryPanel();
            }}
            openGlassesPanel={(patientInfo, id, onCloseAction) => {
              openGlassesPanel(patientInfo, id, onCloseAction);
            }}
            closeGlassesPanel={() => {
              closeGlassesPanel();
            }}
            openHearingAidsPanel={(patientInfo, id, onCloseAction) => {
              openHearingAidsPanel(patientInfo, id, onCloseAction);
            }}
            closeHearingAidsPanel={() => {
              closeHearingAidsPanel();
            }}
            openContactLensesPanel={(patientInfo, id, onCloseAction) => {
              openContactLensesPanel(patientInfo, id, onCloseAction);
            }}
            closeContactLensesPanel={() => {
              closeContactLensesPanel();
            }}
            openObservationsPanel={(
              patientInfo,
              objectId,
              onCloseAction,
              category,
            ) => {
              openObservationsPanel(
                patientInfo,
                objectId,
                onCloseAction,
                category,
              );
            }}
            closeObservationsPanel={() => {
              closeObservationsPanel();
            }}
            openHealthDataPanel={(e) => {
              setActionComponent({
                name: e.name,
                component: e.component,
                onRequestClose: e.onRequestClose,
              });
            }}
            closeHealthDataPanel={() => {
              setActionPopup(false);
              setActionComponent(null);
            }}
            openShoppingCartPanel={() => {
              setShowShoppingCart(true);
            }}
            showSC={showShoppingCart}
          />
          <Store
            show={currentShownScreen === "almacen"}
            closeSuppliersPanel={() => {
              closeSuppliersPanel();
            }}
            openProductPanel={(
              family,
              code,
              onCloseAction,
              supplierCode,
              brandList,
            ) => {
              openProductPanel(family, code, onCloseAction);
              if (supplierCode) {
                setSupplierCode(supplierCode);
              }
              setBrandList(brandList);
            }}
            closeProductPanel={() => {
              closeProductPanel();
            }}
            openBulkEditPanel={(family, products, onCloseAction) => {
              openBulkEditPanel(family, products, onCloseAction);
            }}
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            updatedBEProductList={updatedBEProductList}
            removePopupQuestion={() => removePopupQuestion()}
          ></Store>
          <DeliveryNote
            show={currentShownScreen === "almacen-albaran"}
            openDeliveryNotePanel={(code, onCloseAction) => {
              openDeliveryNotePanel(code, onCloseAction);
            }}
            closeDeliveryNotePanel={() => {
              closeDeliveryNotePanel();
            }}
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
          ></DeliveryNote>
          <Suppliers
            show={currentShownScreen === "almacen-proveedores"}
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
          />
          <InvoicePanel
            show={currentShownScreen === "almacen-facturas"}
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
          ></InvoicePanel>
          <CRM
            show={currentShownScreen === "crm"}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            onGoBack={() => goBack()}
          />
          <DocumentManagement
            show={currentShownScreen === "gestion-documental"}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            onGoBack={() => goBack()}
          />
          <LaborControl
            show={currentShownScreen === "control-laboral"}
            agentId={laborControlAgent && laborControlAgent.idAgente}
            agentName={laborControlAgent && laborControlAgent.nombreAgente}
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
          />
          <Orders
            show={currentShownScreen === "almacen-pedidos"}
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            onGoBack={() => goBack()}
          />
          <Dashboard
            show={currentShownScreen === "dashboard"}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            onGoBack={() => goBack()}
            openCashPopup={(
              selectedOpticId,
              type,
              show,
              startDate,
              endDate,
              seeMore,
              opticName,
              agentId,
            ) =>
              openCashPopup(
                selectedOpticId,
                type,
                show,
                startDate,
                endDate,
                seeMore,
                opticName,
                agentId,
              )
            }
          />
          <DashboardSales
            show={currentShownScreen === "dashboard-ventas"}
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            openCashPopup={(
              selectedOpticId,
              type,
              show,
              startDate,
              endDate,
              seeMore,
              opticName,
              agentId,
            ) =>
              openCashPopup(
                selectedOpticId,
                type,
                show,
                startDate,
                endDate,
                seeMore,
                opticName,
                agentId,
              )
            }
          />
          <DashboardStore
            show={currentShownScreen === "dashboard-almacen"}
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            openCashPopup={(
              selectedOpticId,
              type,
              show,
              startDate,
              endDate,
              seeMore,
              opticName,
              agentId,
            ) =>
              openCashPopup(
                selectedOpticId,
                type,
                show,
                startDate,
                endDate,
                seeMore,
                opticName,
                agentId,
              )
            }
          />
          <DashboardPatients
            show={currentShownScreen === "dashboard-pacientes"}
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            openCashPopup={(
              selectedOpticId,
              type,
              show,
              startDate,
              endDate,
              seeMore,
              opticName,
              agentId,
            ) =>
              openCashPopup(
                selectedOpticId,
                type,
                show,
                startDate,
                endDate,
                seeMore,
                opticName,
                agentId,
              )
            }
          />
          <Calendar
            show={currentShownScreen === "agenda"}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
              onClickExtra1,
              textExtra1,
              onClickExtra2,
              textExtra2,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
                onClickExtra1,
                textExtra1,
                onClickExtra2,
                textExtra2,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            onGoBack={() => goBack()}
          />
          <Sales
            show={currentShownScreen === "ventas"}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
              onClickExtra1,
              textExtra1,
              onClickExtra2,
              textExtra2,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
                onClickExtra1,
                textExtra1,
                onClickExtra2,
                textExtra2,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            onGoBack={() => goBack()}
            debtor={paramsSales && paramsSales.debtor}
            orderer={paramsSales && paramsSales.orderer}
          />
          <Sale
            show={currentShownScreen === "venta"}
            ref={screenSaleRef}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
              onClickExtra1,
              textExtra1,
              onClickExtra2,
              textExtra2,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
                onClickExtra1,
                textExtra1,
                onClickExtra2,
                textExtra2,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            onGoBack={() => goBack()}
            saleId={paramsSale && paramsSale.saleId}
            orderCards={paramsSale && paramsSale.orderCards}
            orderPatientId={paramsSale && paramsSale.orderPatientId}
            createdSale={paramsSale && paramsSale.createdSale}
          />
          <Order
            show={currentShownScreen === "encargo"}
            ref={screenOrderRef}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
              onClickExtra1,
              textExtra1,
              onClickExtra2,
              textExtra2,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
                onClickExtra1,
                textExtra1,
                onClickExtra2,
                textExtra2,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            onGoBack={() => goBack()}
            saleId={paramsOrder && paramsOrder.saleId}
            orderCards={paramsOrder && paramsOrder.orderCards}
            orderPatientId={paramsOrder && paramsOrder.orderPatientId}
          />
          <Quote
            show={currentShownScreen === "presupuesto"}
            ref={screenQuoteRef}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
              onClickExtra1,
              textExtra1,
              onClickExtra2,
              textExtra2,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
                onClickExtra1,
                textExtra1,
                onClickExtra2,
                textExtra2,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            onGoBack={() => goBack()}
            saleId={paramsQuote && paramsQuote.saleId}
            orderCards={paramsQuote && paramsQuote.orderCards}
            orderPatientId={paramsQuote && paramsQuote.orderPatientId}
          />
          <Proforma
            show={currentShownScreen === "proforma"}
            ref={screenProformaRef}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
              onClickExtra1,
              textExtra1,
              onClickExtra2,
              textExtra2,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
                onClickExtra1,
                textExtra1,
                onClickExtra2,
                textExtra2,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            onGoBack={() => goBack()}
            saleId={paramsProforma && paramsProforma.saleId}
            orderCards={paramsProforma && paramsProforma.orderCards}
            orderPatientId={paramsProforma && paramsProforma.orderPatientId}
          />
          <Settings
            show={currentShownScreen === "configuracion"}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            onGoBack={() => goBack()}
          />
          <Textfields
            show={currentShownScreen === "debug-textfields"}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            onGoBack={() => goBack()}
          />
          <Exports
            show={currentShownScreen === "debug-exports"}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            onGoBack={() => goBack()}
          />
          <Skeleton
            show={currentShownScreen === "debug-skeleton"}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            onGoBack={() => goBack()}
          />
          <CashPopupDebug
            show={currentShownScreen === "debug-cash-popup"}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            onGoBack={() => goBack()}
          />
          <Reports
            show={currentShownScreen === "debug-reports"}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            onGoBack={() => goBack()}
          />
          <OnlineOrders
            show={currentShownScreen === "debug-online-orders"}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            onGoBack={() => goBack()}
          />
          <WacomSignature
            show={currentShownScreen === "debug-wacom-signature"}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            onGoBack={() => goBack()}
          />
          <GodexPrinting
            show={currentShownScreen === "debug-godex-printing"}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            onGoBack={() => goBack()}
          />
          <Empty
            show={currentShownScreen === ""}
            onClickMenuOption={(screenId, params) =>
              clickMenuOption(screenId, params)
            }
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            removePopupQuestion={() => removePopupQuestion()}
            onGoBack={() => goBack()}
          />
        </div>
      </div>
    </div>
  );
}
